import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

import arvrImage1 from '../assets/images/services/it/CCTV1.jpg';
import arvrImage2 from '../assets/images/services/it/CCTV2.jpg';
import arvrImage3 from '../assets/images/services/it/EMS1.jpg';
import arvrImage4 from '../assets/images/services/it/ENTRANCE MANAGEMENT.jpg';

import softwareVideo from '../assets/videos/software/ar-vr.mp4';

import arvrBenefitsImage from '../assets/images/software/VR.jpg';

const SoftwareARVRPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="AR/VR Solutions" description="Augmented reality and virtual reality development in DRC. Immersive experiences and interactive solutions by Cool & Care." keywords="AR VR DRC, augmented reality, virtual reality, immersive technology Kinshasa" />
      <ServiceSchema name="AR/VR Solutions" description="Augmented reality and virtual reality development for immersive experiences." url="/software-ar-vr" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'AR/VR', url: '/software-ar-vr' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareARVR.name')}
      serviceDescription={t('servicePage.services.softwareARVR.description')}
      videoUrl={softwareVideo}
      productImages={[
        arvrImage1,
        arvrImage2,
        arvrImage3,
        arvrImage4
      ]}
      features={t('servicePage.services.softwareARVR.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareARVR.benefits', { returnObjects: true }) as string[]}
      benefitsImage={arvrBenefitsImage}
    />
    </>
  );
};

export default SoftwareARVRPage;

